<template>
	<div>
		<div class="flex w-full gap-4 mb-6">
			<div class="flex flex-wrap w-3/5">
				<BaseInput v-model="searchValue" label="Suche" class="flex-grow" @input="search" mask="UUUUUUUUUUUUUUUUUUUUUU" />
			</div>
			<div>
				<BaseButton @click="search" class="mt-8 searchline-button btn-blue">
					{{ $t('search') }}
				</BaseButton>
			</div>
		</div>
		<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
			<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
				<div class="overflow-hidden border-b border-gray-200">
					<table class="min-w-full divide-y divide-gray-200">
						<thead class="pb-4">
							<tr :class="{ 'cursor-pointer': false }">
								<OverviewTableHeader :label="$t('license_plate').toString()" class="w-1/6" />
								<OverviewTableHeader :label="$t('vehicle').toString()" class="w-2/6" />
								<OverviewTableHeader :label="$t('start').toString()" class="w-1/6" />
								<OverviewTableHeader :label="$t('currently_rented').toString()" class="w-2/6" />
								<th class="w-1">&nbsp;</th>
							</tr>
						</thead>
						<tbody class="bg-white divide-y divide-gray-200">
							<tr class="hover:bg-gray-300" :class="{ 'cursor-pointer': false }" v-for="car in filteredContracts" :key="car.vehicle.id">
								<td class="px-6 py-1 text-left">
									{{ car.vehicle.licensePlate.text }}
								</td>
								<td class="px-6 py-1 text-left">
									<div>
										{{ car.vehicle.manufacturer }}
									</div>
									<div>{{ car.vehicle.model }}</div>
								</td>
								<td class="px-6 py-1 text-left">
									{{ formatDate(car.rentStartDate) }}
								</td>
								<td
									class="px-6 py-1 text-left"
									@click="
										$router.push({ name: 'management.process.edit', params: { processId: car.damageCase.id, customer: car.damageCase.customer.id } })
									"
								>
									{{
										car.damageCase.customer.gender === 'company'
											? car.damageCase.customer.companyName
											: car.damageCase.customer.firstName + ' ' + car.damageCase.customer.lastName
									}}
									/ {{ car.damageCase.imdNetId }}
								</td>

								<td class="px-6 py-1 text-center">
									<BaseButton class="text-base" @click="$router.push({ name: 'RentalCarContractReturnForm', params: { contractId: car.id } })">{{
										$t('return')
									}}</BaseButton>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getStringFromDate } from '@/plugins/Utils';
import BaseButton from '@/components/forms/buttons/BaseButton';
import OverviewTableHeader from '@/views/damagecases/OverviewTableHeader.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
export default {
	name: 'RentalCarContractReturnList',
	components: { OverviewTableHeader, BaseButton, BaseInput },
	props: {
		rentalCarContractList: {},
	},
	data() {
		return {
			searchValue: '',
			filteredContracts: [],
		};
	},
	methods: {
		formatDate: timestamp => {
			const newDate = new Date(timestamp * 1000);
			return getStringFromDate(newDate);
		},
		search() {
			const searchTerm = this.searchValue;
			if (searchTerm !== '') {
				this.filteredContracts = this.rentalCarContractList.filter(function(element) {
					return (
						element.vehicle.licensePlate.text.toLowerCase().includes(searchTerm.toLowerCase()) ||
						element.vehicle.manufacturer.toLowerCase().includes(searchTerm.toLowerCase()) ||
						(element.damageCase.customer.lastName != null
							? element.damageCase.customer.lastName.toLowerCase().includes(searchTerm.toLowerCase())
							: element.damageCase.customer.companyName.toLowerCase().includes(searchTerm.toLowerCase()))
					);
				});
			} else {
				this.filteredContracts = this.rentalCarContractList;
			}
		},
	},
	mounted() {
		this.filteredContracts = this.rentalCarContractList;
	},
};
</script>
